var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("sc-form", {
        ref: "credentialsForm",
        attrs: { autocomplete: "off" },
        scopedSlots: _vm._u([
          {
            key: "fields",
            fn: function(ref) {
              var fields = ref.fields
              return [
                _c("div", { staticClass: "mainContent" }, [
                  !_vm.isEdit
                    ? _c(
                        "div",
                        { staticClass: "mainContent__paragraphs" },
                        _vm._l(_vm.schemaBased.description, function(
                          description
                        ) {
                          return _c("p", { key: description.id }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(description) +
                                "\n          "
                            )
                          ])
                        })
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mainContent__table" },
                    [
                      _c("input-fields", {
                        ref: "inputFieldsRef",
                        attrs: { schemaBased: _vm.schemaBased }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("help-button")
              ]
            }
          },
          {
            key: "actions",
            fn: function(ref) {
              var isValid = ref.isValid
              return [
                _vm.isEdit
                  ? _c(
                      "div",
                      { staticClass: "editButtons" },
                      [
                        _c("sc-button", {
                          staticClass: "startIntegration",
                          attrs: { text: "Cancelar", theme: "primary" }
                        }),
                        _vm._v(" "),
                        _c("sc-button", {
                          staticClass: "startIntegration",
                          attrs: { text: "Salvar", theme: "primary" }
                        })
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "navigateButtons" },
                      [
                        _c("sc-button", {
                          staticClass: "startIntegration",
                          attrs: {
                            text: "Próximo",
                            theme: "primary",
                            type: "submit"
                          },
                          on: { click: _vm.navigateNext }
                        })
                      ],
                      1
                    )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ec050b02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec050b02","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/components/sc-credentials/ScCredentials.vue
// module id = null
// module chunks = 